"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constant = require("@airasia/phoenix-components/components/Theme/constant");
var _constant2 = require("@airasia/phoenix-components/components/Link/constant");
var _constant3 = require("@airasia/phoenix-components/components/Tag/constant");
var _constant4 = require("@airasia/phoenix-components/components/Title/constant");
var _constant5 = require("./constant");
var _default = {
  PropTypes: {
    heading: _propTypes.default.exact({
      widgetName: _propTypes.default.string,
      widgetID: _propTypes.default.string,
      widgetWidth: _propTypes.default.oneOf(_constant5.ARR_COLUMN_SPAN),
      cardCount: _propTypes.default.string,
      layoutName: _propTypes.default.string,
      headline: _propTypes.default.string,
      subHeadline: _propTypes.default.string,
      showMoreURL: _propTypes.default.string,
      showMoreText: _propTypes.default.string,
      showMoreTextTarget: _propTypes.default.oneOf(Object.keys(_constant2.LINK_TARGET)),
      showMoreCallBack: _propTypes.default.func,
      showMoreType: _propTypes.default.oneOf(Object.keys(_constant2.REDIRECTION_TYPE)),
      gtmParameters: _propTypes.default.object,
      minCardsThreeColumn: _propTypes.default.string,
      decimalType: _propTypes.default.string,
      titleAlign: _propTypes.default.string,
      titleMargin: _propTypes.default.string,
      headlineType: _propTypes.default.oneOf(_constant4.ARR_TITLE_TYPES),
      headlineStyle: _propTypes.default.string,
      headlineFontSize: _propTypes.default.string,
      headlineFontWeight: _propTypes.default.string,
      headlineLineHeight: _propTypes.default.string,
      subHeadlineFontSize: _propTypes.default.string,
      subHeadlineFontWeight: _propTypes.default.string,
      subHeadlineFontColor: _propTypes.default.string
    }),
    data: _propTypes.default.arrayOf(_propTypes.default.exact({
      url: _propTypes.default.string,
      cta: _propTypes.default.string,
      primaryLabel: _propTypes.default.string,
      image: _propTypes.default.string,
      lowResolutionImageUrl: _propTypes.default.string,
      secondaryLabel: _propTypes.default.string,
      attractText: _propTypes.default.string,
      title: _propTypes.default.string,
      subtitle: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.instanceOf(Date)]),
      star: _propTypes.default.string,
      location: _propTypes.default.string,
      priceDisclaimer: _propTypes.default.string,
      discount: _propTypes.default.string,
      originalprice: _propTypes.default.string,
      price: _propTypes.default.string,
      priceClarification: _propTypes.default.string,
      rating: _propTypes.default.string,
      secondaryImage: _propTypes.default.string,
      labelColor: _propTypes.default.string,
      mobileAppImageURL: _propTypes.default.string,
      newTab: _propTypes.default.string,
      position: _propTypes.default.string,
      productID: _propTypes.default.string,
      hidden: _propTypes.default.string,
      productType: _propTypes.default.string,
      currencyCode: _propTypes.default.string,
      accessibilityText: _propTypes.default.string,
      cndisclaimerLine1: _propTypes.default.string,
      cndisclaimerLine2: _propTypes.default.string,
      chinaURL: _propTypes.default.string,
      companyURL: _propTypes.default.string,
      companyName: _propTypes.default.string,
      countDown: _propTypes.default.string,
      timer: _propTypes.default.string,
      timerEndDateTime: _propTypes.default.string,
      timerLabelEndDays: _propTypes.default.string,
      timerLabelEndHours: _propTypes.default.string,
      timerLabelStartDays: _propTypes.default.string,
      timerLabelStartHours: _propTypes.default.string,
      timerStartDateTime: _propTypes.default.string,
      timerTimeZone: _propTypes.default.string,
      formattedPriceWeb: _propTypes.default.string,
      formattedPriceMob: _propTypes.default.string,
      formattedOriginalPriceWeb: _propTypes.default.string,
      formattedOriginalPriceMob: _propTypes.default.string,
      colorButton: _propTypes.default.oneOf(_constant.ARR_COLORS),
      hoverColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
      backgroundColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
      hoverBackgroundColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
      widthButton: _propTypes.default.string,
      customPropertiesButton: _propTypes.default.object,
      tags: _propTypes.default.arrayOf(_propTypes.default.shape({
        key: _propTypes.default.string,
        label: _propTypes.default.string,
        url: _propTypes.default.string,
        color: _propTypes.default.oneOf(_constant.ARR_COLORS),
        backgroundColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
        padding: _propTypes.default.string,
        margin: _propTypes.default.string,
        tagTarget: _propTypes.default.oneOf(Object.keys(_constant2.LINK_TARGET)),
        type: _propTypes.default.oneOf(_constant3.ARR_TEXT_TYPE),
        handleOnClick: _propTypes.default.func
      })),
      ctaConfig: _propTypes.default.shape({
        color: _propTypes.default.oneOf(_constant.ARR_COLORS),
        size: _propTypes.default.oneOf(_constant.ARR_FONT_SIZE),
        target: _propTypes.default.oneOf(Object.keys(_constant2.LINK_TARGET)),
        type: _propTypes.default.oneOf(Object.keys(_constant2.REDIRECTION_TYPE)),
        href: _propTypes.default.string.isRequired,
        callback: _propTypes.default.func,
        queryParams: _propTypes.default.object
      })
    })),
    indexNumber: _propTypes.default.number,
    gtmConsumerName: _propTypes.default.string,
    viewPort: _propTypes.default.string,
    fireGtm: _propTypes.default.func,
    enableProgressiveImageLoading: _propTypes.default.bool,
    lazyLoadImage: _propTypes.default.bool,
    isIE: _propTypes.default.bool,
    queryParams: _propTypes.default.object,
    isLoading: _propTypes.default.bool,
    environment: _propTypes.default.string,
    templateType: _propTypes.default.string.isRequired,
    cardConfig: _propTypes.default.object,
    allowLocaleFormat: _propTypes.default.bool,
    locale: _propTypes.default.string,
    localeConfig: _propTypes.default.shape({
      date: _propTypes.default.object,
      time: _propTypes.default.object
    }),
    theme: _propTypes.default.string,
    customProperties: _propTypes.default.string,
    accessible: _propTypes.default.bool,
    showFormattedPrice: _propTypes.default.bool,
    carouselWidgetOrder: _propTypes.default.number,
    isHideFooter: _propTypes.default.bool,
    gaID: _propTypes.default.string
  },
  DefaultProps: {
    isLoading: false,
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    environment: 'DEVELOPMENT',
    allowLocaleFormat: false,
    isHideFooter: false,
    widgetName: 'Carousel',
    showMoreTextTarget: 'self'
  }
};
exports.default = _default;